import { render, staticRenderFns } from "./ServiceNumberDataNationalUsageLineChart.vue?vue&type=template&id=ed153b54&scoped=true&"
import script from "./ServiceNumberDataNationalUsageLineChart.vue?vue&type=script&lang=js&"
export * from "./ServiceNumberDataNationalUsageLineChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed153b54",
  null
  
)

export default component.exports